import { render, staticRenderFns } from "./SpendInformation.vue?vue&type=template&id=282ddc90&scoped=true&"
import script from "./SpendInformation.vue?vue&type=script&lang=js&"
export * from "./SpendInformation.vue?vue&type=script&lang=js&"
import style0 from "./SpendInformation.vue?vue&type=style&index=0&id=282ddc90&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "282ddc90",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VSimpleTable } from 'vuetify/lib/components/VDataTable';
installComponents(component, {VSimpleTable})
